import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ProjectApiService } from './project-api.service';

@Injectable()
export class SharedProjectResolver  {
  constructor(private projectApiService: ProjectApiService) {}

  public resolve(route: ActivatedRouteSnapshot): Observable<any> | Promise<any> | any {
    return this.projectApiService.getSharedProject(route.queryParams.id, route.queryParams.version);
  }
}
